/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { ServiceaftaleConsumerDto as OkEgisServiceModelsDtoServiceaftaleConsumerDto } from '../models/OK/Egis/Service/Models/DTO/serviceaftale-consumer-dto';

@Injectable({
  providedIn: 'root',
})
export class ServiceaftaleConsumerService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getServiceaftaleByOkKundeAftalenr
   */
  static readonly GetServiceaftaleByOkKundeAftalenrPath = '/api/v1/ServiceaftaleConsumer/GetServiceaftaleByOkKundeAftalenr/{okKundeAftalenr}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getServiceaftaleByOkKundeAftalenr()` instead.
   *
   * This method doesn't expect any request body.
   */
  getServiceaftaleByOkKundeAftalenr$Response(params: {
    okKundeAftalenr: number;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<StrictHttpResponse<OkEgisServiceModelsDtoServiceaftaleConsumerDto>> {

    const rb = new RequestBuilder(this.rootUrl, ServiceaftaleConsumerService.GetServiceaftaleByOkKundeAftalenrPath, 'get');
    if (params) {
      rb.path('okKundeAftalenr', params.okKundeAftalenr, {});
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OkEgisServiceModelsDtoServiceaftaleConsumerDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getServiceaftaleByOkKundeAftalenr$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getServiceaftaleByOkKundeAftalenr(params: {
    okKundeAftalenr: number;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<OkEgisServiceModelsDtoServiceaftaleConsumerDto> {

    return this.getServiceaftaleByOkKundeAftalenr$Response(params).pipe(
      map((r: StrictHttpResponse<OkEgisServiceModelsDtoServiceaftaleConsumerDto>) => r.body as OkEgisServiceModelsDtoServiceaftaleConsumerDto)
    );
  }

}
